// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1VwQu","rightAdornment":"Header_rightAdornment__18z_9"};